import { Link } from "react-router-dom";
import { COMPANY } from "../lib/data";

// Inline SVG logo mark (gradient badge + wrench) — crisp & fast, no image request
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="lbd-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2563EB" />
          <stop offset="1" stopColor="#16A34A" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="11" fill="url(#lbd-grad)" />
      <g transform="translate(8 8) scale(1)" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </g>
    </svg>
  );
}

export default function Logo({ to = "/", dark = false, className = "" }) {
  return (
    <Link to={to} className={`flex items-center gap-2.5 group ${className}`} data-testid="nav-logo">
      <LogoMark size={38} className="shadow-md shadow-brand/25 rounded-[11px]" />
      <span className="flex flex-col leading-none">
        <span className={`font-display text-base font-extrabold tracking-tight ${dark ? "text-white" : "text-ink"}`}>
          {COMPANY.name}
        </span>
        <span className={`text-[0.62rem] font-semibold tracking-wide ${dark ? "text-white/50" : "text-ink-muted"}`}>
          Dépannage 24/7
        </span>
      </span>
    </Link>
  );
}
